import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    if (this.element.tagName.toUpperCase() === "INPUT") {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

      if (userTimezone.toString().trim() === "") {
        throw new Error(`Unable to determine the user timezone from Intl: ${userTimezone} / timezoneOffset: ${new Date().getTimezoneOffset()}`)
      } else {
        this.element.value = userTimezone
      }

    } else {
      throw new Error(`user-time-zone-hidden-input Stimulus controller cannot be instantiated from non-input: ${this.element.outerHTML}`)
    }
  }
}
